// extracted by mini-css-extract-plugin
export default {"campaignList":"CampaignList_campaignList__-Pe5F"};